import { oneOf } from 'prop-types';

export const propTypes = { lang: oneOf(['sk', 'en']) };
export const defaultProps = { lang: 'en' };
export const languages = {
  sk: {
    title: 'SK',
    srOnly: 'Prepnúť do slovenčiny',
    link: '/sk/',
  },
  en: {
    title: 'EN',
    srOnly: 'Switch to English',
    link: '/',
  },
};



// WEBPACK FOOTER //
// ./src/data/lang.js